import triggerTracking from '@blueprint/tracking';
import { ArticleCollectionDescription } from './CmsArticleCollection.styles';
import { CmsArticleCollectionProps } from './CmsArticleCollection.type';
import { Carousel } from '@zoopla/cms/carousel';
import { CmsArticleCard } from '@zoopla/cms/article-card';
import { PageSubtitleShort } from '@zoopla-eng/zds-components/headings';
import { Box } from '@zoopla-eng/zds-components/box';
import { Button } from '@zoopla-eng/zds-components/button';

function notEmpty<TValue>(value: TValue | null | undefined): value is TValue {
    return value !== null && value !== undefined;
}

const articleTracking = (
    articleSlug: string,
    articleCategory: string,
    index: number
) => {
    triggerTracking({
        event: 'GAEvent',
        eventCategory: 'content_module',
        eventAction: 'article_clickthrough',
        eventLabel: `/discover/${articleCategory}/${articleSlug}/,${index + 1}`
    });
};

export function CmsArticleCollection({
    articleCollectionData,
    carouselConfig,
    horizontalCardLayout,
    seeMoreLink,
    trackingFunction
}: CmsArticleCollectionProps) {
    let horizontalCardCondition =
        (articleCollectionData?.articles?.total || 0) <= 2;

    if (horizontalCardLayout !== undefined) {
        horizontalCardCondition = horizontalCardLayout;
    }

    return (
        <div>
            {!articleCollectionData?.hideTitleAndDescription && (
                <Box display="flex" justifyContent="space-between">
                    <Box>
                        <PageSubtitleShort>
                            {articleCollectionData?.title}
                        </PageSubtitleShort>
                        <ArticleCollectionDescription>
                            {articleCollectionData?.description}
                        </ArticleCollectionDescription>
                    </Box>
                    {seeMoreLink && (
                        <Box
                            display="none"
                            pt="$S100"
                            {...{
                                '@S200': { display: 'block' }
                            }}
                        >
                            <Button
                                {...{ as: 'a', href: seeMoreLink.buttonUrl }}
                                category={seeMoreLink.category}
                            >
                                {seeMoreLink.buttonLabel}
                            </Button>
                        </Box>
                    )}
                </Box>
            )}
            <Carousel breakpoints={carouselConfig?.breakpoints}>
                {articleCollectionData?.articles?.items
                    .filter(notEmpty)
                    .map((article, articleKey) => (
                        <CmsArticleCard
                            article={article}
                            index={articleKey}
                            key={articleKey}
                            horizontalLayout={horizontalCardCondition}
                            heroArticle={
                                articleCollectionData.articles?.total === 1
                            }
                            trackingFunction={() =>
                                trackingFunction
                                    ? trackingFunction(article, articleKey)
                                    : articleTracking(
                                          article?.slug ?? '',
                                          article?.category?.slug ?? '',
                                          articleKey
                                      )
                            }
                            headingLevel="h3"
                        />
                    ))}
            </Carousel>
        </div>
    );
}

export default CmsArticleCollection;
